export const NumberInputStyle = {
  "& .chakra-number-input__input": {
    // display: "none",
    // paddingLeft: "4px",
    width: "32px",
    border: "1px solid #E2E8F0",
    fontSize: "12px",
    textAlign: "center",
  },
  ".chakraNumberInput__input::focus, .chakraNumberInput__input::active": {
    border: "none",
    backgroundColor: "#ffff00",
    outline: "none",
  },
  //   ".chakra-number-input__input::focus, .chakra-number-input__input::active": {
  //     border: "none",
  //     backgroundColor: "#ff0000",
  //     outline: "none",
  //   },
  "& .chakra-number-input__decrementTrigger, .chakra-number-input__incrementTrigger, .chakra-number-input__control":
    {
      display: "none",
      // backgroundColor: "red",
    },
};

export const activeButtonStyles = {
  backgroundColor: "#007bff",
  color: "#fff",
  _hover: {
    backgroundColor: "#0056b3",
    color: "#fff",
  },
};
